// Region data for dropdown
export const regionOptions = [
  { label: 'United States', value: 'us-east-1' },
  { label: 'India', value: 'ap-south-1' },
];
